import { gql } from "@apollo/client";

export const GET_TOTAL_ASSETS = gql`
  query GetTotalAssets($scopeMrn: String, $workflowMrn: String) {
    assets(scopeMrn: $scopeMrn, workflowMrn: $workflowMrn) {
      totalCount
    }
  }
`;
